export default __webpack_public_path__ + "static/media/gpsapp.0b758498.png";